<template>
  <v-dialog content-class="debug-dialog" v-model="dialog" @keydown.esc="close">
    <div class="d-header">Debug</div>
    <div class="d-container">
      <div v-for="(log, index) in $store.state.Pad.logs" :key="index">{{ log }}</div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
    };
  },

  methods: {
    open() {
      this.confirmResult = undefined;
      this.refreshing = false;
      this.dialog = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close() {
      if (this.resolve) this.resolve(true);
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss">
.debug-dialog {
  height: 90vh !important;
  width: 80vw !important;
  background-color: white;

  .d-header {
    //height: 30px;
    padding: 12px;
    text-align: center;
    font-size: 1.6em;
    background-color: white;

    position: sticky;
    top: 0px;
  }

  .d-container {
    background-color: white;

    //height: 100%;
    width: 100%;
    padding: 12px;
    padding-top: 0px;
  }
}
</style>
